import { Config } from '@leverege/plugin';

/**
 * This will take all args in config.plugins.config and install them
 * into the @leverege/plugin Config object.
 * 
 * The form of the 
 */
export default {
  id: 'molten.LoadConfig',
  sort: -1000000,
  init: molten => {
    const apply = molten.getConfig('plugins/config');
    if (apply == null) {
      return;
    }
    Object.keys(apply).forEach(resource => {
      Object.keys(apply[resource]).forEach(key => {
        Config.set(resource, key, apply[resource][key]);
      });
    });
  }
};